// Ceci est un PSEUDO-CODE JavaScript, il faudrait une implémentation complète
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.before-after-slider-container');
  const handle = document.querySelector('.slider-handle');
  const afterImage = document.querySelector('.after-image');

  let isDragging = false;

  if (!container || !handle || !afterImage) return;

  handle.addEventListener('mousedown', (e) => {
    isDragging = true;
    e.preventDefault(); // Empêche la sélection de texte
  });

  document.addEventListener('mouseup', () => {
    isDragging = false;
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;

    const containerRect = container.getBoundingClientRect();
    let newX = e.clientX - containerRect.left;

    // Limiter le déplacement du curseur
    newX = Math.max(0, Math.min(newX, containerRect.width));

    handle.style.left = `${newX}px`;
    afterImage.style.width = `${newX}px`;
  });

  // Gérer le redimensionnement de la fenêtre pour s'assurer que tout reste synchronisé
  window.addEventListener('resize', () => {
    const containerRect = container.getBoundingClientRect();
    const currentHandleLeft = parseFloat(handle.style.left);
    if (isNaN(currentHandleLeft)) { // Si pas encore déplacé, initialiser
        handle.style.left = '50%';
        afterImage.style.width = '50%';
    } else {
        const newHandleLeft = (currentHandleLeft / containerRect.width) * 100;
        handle.style.left = `${newHandleLeft}%`;
        afterImage.style.width = `${newHandleLeft}%`;
    }
  });
});